import { render, staticRenderFns } from "./BigPanel.vue?vue&type=template&id=fc1ef1a4&"
import script from "./BigPanel.vue?vue&type=script&lang=js&"
export * from "./BigPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports